goog.provide("shadow.js.shim.module$dayjs$locale$sr");
goog.provide("module$shadow_js_shim_module$dayjs$locale$sr");
shadow.js.shim.module$dayjs$locale$sr = shadow.js.nativeProvides["dayjs/locale/sr"] = require("dayjs/locale/sr");
module$shadow_js_shim_module$dayjs$locale$sr.default = shadow.js.shim.module$dayjs$locale$sr;
